import createRequestTypes from "../../../../helpers/createReduxActionTypes";

export const APPLY_WORKOUT_TEMPLATE = createRequestTypes("APPLY_WORKOUT_TEMPLATE");
export const CHANGE_WORKOUT = createRequestTypes("CHANGE_WORKOUT");
export const GET_CLIENT_WORKOUTS = createRequestTypes("GET_CLIENT_WORKOUTS");
export const WORKOUT_TEMPLATE_MODAL_OPEN = "WORKOUT_TEMPLATE_MODAL_OPEN";
export const DELETE_WORKOUT_PLAN = createRequestTypes("DELETE_WORKOUT_PLAN");
